/**
 * Rangos de fecha para el filtro de Informes > Por Categoría.
 * Fechas en calendario local (YYYY-MM-DD), sin desfases UTC.
 */

export function fechaLocalAISO(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Resta meses sin desbordar el día (31 mar → 28/29 feb, no 3 mar). */
export function restarMesesConservandoDia(date, meses) {
  const y = date.getFullYear();
  const m = date.getMonth();
  const d = date.getDate();
  const target = new Date(y, m - meses, 1);
  const lastDay = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
  target.setDate(Math.min(d, lastDay));
  return target;
}

/** Resta años sin desbordar (29 feb → 28 feb en año no bisiesto). */
export function restarAnosConservandoDia(date, anos) {
  const y = date.getFullYear() - anos;
  const m = date.getMonth();
  const d = date.getDate();
  const lastDay = new Date(y, m + 1, 0).getDate();
  return new Date(y, m, Math.min(d, lastDay));
}

/**
 * Último mes natural: desde el mismo día hace un mes hasta hoy (ambos inclusive).
 */
export function rangoUltimoMesNatural(refDate = new Date()) {
  const hasta = new Date(refDate.getFullYear(), refDate.getMonth(), refDate.getDate());
  const desde = restarMesesConservandoDia(hasta, 1);
  return { desde: fechaLocalAISO(desde), hasta: fechaLocalAISO(hasta) };
}

/** Mes calendario en curso: día 1 hasta el último día del mes. */
export function rangoMesEnCurso(refDate = new Date()) {
  const y = refDate.getFullYear();
  const m = refDate.getMonth();
  const desde = new Date(y, m, 1);
  const hasta = new Date(y, m + 1, 0);
  return { desde: fechaLocalAISO(desde), hasta: fechaLocalAISO(hasta) };
}

/** Año calendario en curso: 1 ene hasta 31 dic. */
export function rangoAnoEnCurso(refDate = new Date()) {
  const y = refDate.getFullYear();
  return { desde: `${y}-01-01`, hasta: `${y}-12-31` };
}

/**
 * Último año natural: desde el mismo día hace un año hasta hoy (ambos inclusive).
 */
export function rangoUltimoAnoNatural(refDate = new Date()) {
  const hasta = new Date(refDate.getFullYear(), refDate.getMonth(), refDate.getDate());
  const desde = restarAnosConservandoDia(hasta, 1);
  return { desde: fechaLocalAISO(desde), hasta: fechaLocalAISO(hasta) };
}

/** True si la fecha del gasto (YYYY-MM-DD) está en [desde, hasta] inclusive. */
export function gastoEnRangoFecha(gasto, desde, hasta) {
  if (!desde && !hasta) return true;
  if (gasto == null || gasto.fecha == null || gasto.fecha === '') return false;
  const dia = String(gasto.fecha).split('T')[0];
  if (!dia) return false;
  if (desde && dia < desde) return false;
  if (hasta && dia > hasta) return false;
  return true;
}
